import React, { useState, useContext, useEffect } from "react";
import "../homepage.css"
import "./innercss.css";
import { Form, Link, redirect } from "react-router-dom";
import UserApplication from "../UserContext/UserContext";
import { useParams } from 'react-router-dom'
import { barely, barely_black_bg_img } from "../../../public/LoginImages/importimages";


const BidderRegister = () => {
  let data = useContext(UserApplication)
  const { SetNotification, paymentdata, GetAuctionsList, TenderRegisterHash, TenderPayment, DownloadReciept, setpaymentdata } = data
  const [form, setform] = useState([])
  const [Auction, SetAuction] = useState([])
  const { Auction_ID, Auction_Name } = useParams()
  const [forminf, SetForminf] = useState({
    Bidder_CompanyName: "",
    Address: "",
    City: "",
    PinCode: "",
    GST_No: "",
    PAN_No: "",
    Mobile_No: "",
    Email: "",
    Tender_ID: "",
    Tender_Name: "",
    TenderFee: "",
    ErnestMoneyDeposit: "",
    GST: "",
    Account_Number: "",
    IFSC_CODE: "",
    BANK_NAME: "",
    Account_HolderName: "",
    BranchName: ""
  })
console.log(forminf.IFSC_CODE);

  const [recieptview, showrecieptview] = useState(true)
  const [isGSTValid, setIsGSTValid] = useState(false);
  const [isPANValid, setIsPANValid] = useState(false);
  const [accountnum, setaccountnum] = useState(false);
  const [isIfscValid, setIsIfscValid] = useState(false);

  const validateIfsc = async () => {
    let IFSC_CODE = document.getElementById('IFSC_CODE').value.toUpperCase();
    try {
      const response = await fetch(`https://ifsc.razorpay.com/${IFSC_CODE}`);
      if (response.ok) {
        setIsIfscValid(true);
      } else {
        setIsIfscValid(false);
      }
    } catch (error) {
      setIsIfscValid(false);
      console.error("Error validating IFSC code:", error);
    }
  };


  const checkGSTandPAN = () => {
    try {
      let GST_No = document.getElementById('GST_No').value.toUpperCase();
      let PAN_No = document.getElementById('PAN_No').value.toUpperCase();

      const gstRegex = /^([0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1})$/;
      const panRegex = /^([A-Z]{5}[0-9]{4}[A-Z]{1})$/;

      const isGSTValid = gstRegex.test(GST_No);
      const isPANValid = panRegex.test(PAN_No);

      const modifiedString = GST_No.slice(2, -3);

      if (PAN_No === modifiedString) {
        setIsPANValid(isPANValid);
      } else {
        setIsPANValid(false);
      }

      setIsGSTValid(isGSTValid);
    } catch (error) {
      console.error('Error in checkGSTandPAN:', error);
      throw error;
    }
  };

  useEffect(() => {
    try {
      setpaymentdata(null)
      getdata()
    } catch (error) {
      console.error('Error in useEffect:', error);
      throw error;
    }
  }, [])

  const getdata = async () => {
    try {
      let d = await GetAuctionsList('GetTenderInformation', null, Auction_ID, Auction_Name)
      SetAuction(d[0])
      forminf.Tender_ID = d[0].Tender_ID
      forminf.Tender_Name = d[0].Tender_Name
      forminf.TenderFee = d[0].TenderFee
      forminf.ErnestMoneyDeposit = d[0].ErnestMoneyDeposit
      forminf.GST = d[0].GST
    } catch (error) {
      console.error('Error in getdata:', error);
      throw error;
    }

  }


  const setdata = (e) => {
    try {
      let check = document.getElementById('checkacnumber').value
      let acnum = document.getElementById('Account_Number').value
      setaccountnum(check === acnum && check != "" && acnum != "" ? true : false)
      const { id, value } = e.target;
      let finalValue = value;
      // Ensure IFSC_CODE is always uppercase
      if (id === 'IFSC_CODE') {
        finalValue = value.toUpperCase();
      }
      SetForminf({ ...forminf, [id]: finalValue });
    } catch (error) {
      console.error('Error in setdata:', error);
      throw error;
    }
  }

  const gethashkey = async () => {

    try {
      let token = await TenderRegisterHash(forminf);

      if (token === "already Registered") {
        alert('Already registered following details')
        return SetNotification({ notice: "Already registered with this pan and gst", color: "hotpink" })
      } else {
        var easebuzz = new window.EasebuzzCheckout('M6TD26M62', 'test');
        // var easebuzz = new window.EasebuzzCheckout('AP6Z6L5I6R', 'prod');
        window.location.href = 'https://testpay.easebuzz.in/pay/' + token?.data
        // window.location.href = 'https://pay.easebuzz.in/pay/' + token?.data
        // let response1 = null;
        // var options = {
        //   access_key: token.data,
        //   onResponse: async (response1) => {
        //     await TenderPayment(response1, forminf);
        //     if (response1.status === 'success' || response1.status === 'pending') {
        //       SetNotification({ notice: "Payment Successful", color: "lightgreen" })
        //       window.location.href = '/Dashboard/DownloadReciept/' + forminf.Tender_ID + '/' + forminf.GST_No + '/' + forminf.PAN_No
        //     }
        //   },
        //   theme: '#123456'
        // };
        // easebuzz.initiatePayment(options);
      }
    } catch (error) {
      console.error('Error in gethashkey:', error);
      throw error;
    }
  };


  return (
    <div style={{ backgroundImage: `url('${barely_black_bg_img}')`, backgroundSize: 'cover',backgroundPosition: 'center',backgroundRepeat: 'no-repeat',alignSelf: 'center',display: 'grid',justifyContent: "center",padding: '1rem'}}>

      <div className="card" style={{ backgroundColor: 'rgb(255,255,255,0.8)', height: 'fit-content' }} >
        <h5 className="card-header" style={{ textAlign: "center" }}><b>{Auction.Tender_Name}</b></h5>
        <div className="card-body">
          <h5 className="card-title">{Auction.Auction_Name}</h5>

          <div style={{ display: 'flex' }} className='my-2'>
            <span className='form-control mx-2' style={{ background: "transparent", border: 'none', display: 'grid' }}> <b>EMD</b> <b className="text-success">{Auction.ErnestMoneyDeposit} Rs</b> </span>
            <span className='form-control mx-2' style={{ background: "transparent", border: 'none' }}> <b>Scheme Fee</b> <br />{Auction.TenderFee} Rs</span>
          </div>
          <div style={{ display: 'flex' }} className='my-2'>
            <span className='form-control mx-2' style={{ background: "transparent", border: 'none' }}> <b>PO Number</b> <br />{Auction.PO_Number}</span>
            <span className='form-control mx-2' style={{ background: "transparent", border: 'none' }}> <b>GST</b> <br />{Auction.GST}%</span>
          </div>

        </div>
      </div>



     <div style={{display:"grid",justifyContent:"center"}}>
     <div className="card-body my-3" style={{ width: "80vw" }}>
        <Form id='form1' onSubmit={() => { isPANValid === true && accountnum === true && isIfscValid === true ? gethashkey() : alert('incorrect details') }} style={{ backgroundColor: 'rgb(255,255,255,0.8)' }} >
          <hr></hr>
          <h5 className="card-header" style={{ textAlign: "center" }}><b>Registeration Form</b></h5>
          <hr></hr>
          <div className="bidder_register_form">
            <div className="mx-3" style={{ width: "33rem" }}>
              <label>Bidder_CompanyName*:</label>
              <input type="text" id="Bidder_CompanyName" placeholder="Enter Bidder_CompanyName" className="form-control" required onChange={(e) => { setdata(e) }} />
            </div>
            <div className="mx-3" style={{ width: "33rem" }}>
              <label>Address*:</label>
              <input type="text" id="Address" placeholder="Enter Address" className="form-control" required onChange={(e) => { setdata(e) }} />
            </div>
          </div>
          <div className="bidder_register_form">
            <div className="mx-3" style={{ width: "33rem" }}>
              <label>City*:</label>
              <input type="text" id="City" placeholder="Enter City" className="form-control" required onChange={(e) => { setdata(e) }} />
            </div>
            <div className="mx-3" style={{ width: "33rem" }}>
              <label>PinCode*:</label>
              <input type="tel" id="PinCode" pattern="\d{6}" minLength="6" maxLength="6" placeholder="Enter Pin Code" className="form-control"
                onInput={(e) => {
                  let enteredValue = e.target.value;
                  enteredValue = enteredValue.slice(0, 6).replace(/\D/g, '');
                  e.target.value = enteredValue;
                }}
                onChange={(e) => { setdata(e) }}
                required
              />
            </div>
          </div>
          <div className="bidder_register_form">
            <div className="mx-3" style={{ width: "33rem" }}>
              <label>GST_No*:</label>
              <input type="text" id="GST_No" placeholder="Enter GST No." className="form-control" required onChange={(e) => { setdata(e); checkGSTandPAN() }} style={{ textTransform: 'uppercase' }} />
              <b style={{ color: isGSTValid === false ? 'red' : 'green' }}>{isGSTValid === false ? 'incorrect GST' : 'Correct'}</b>
            </div>
            <div className="mx-3" style={{ width: "33rem" }}>
              <label>PAN_No*:</label>
              <input type="text" id="PAN_No" placeholder="Enter PAN No." className="form-control" required onChange={(e) => { setdata(e); checkGSTandPAN() }} style={{ textTransform: 'uppercase' }} />
              <b style={{ color: isPANValid === false ? 'red' : 'green' }}>{isPANValid === false ? 'PAN details does not match with GST/PAN Invalid' : 'Correct'}</b>
            </div>
          </div>
          <div className="bidder_register_form">
            <div className="mx-3" style={{ width: "33rem" }}>
              <label>Mobile_No*:</label>
              <input type="tel" className="form-control" id="Mobile_No" pattern="\d{10}" minLength="10" maxLength="10" placeholder="Enter Mobile No."
                onInput={(e) => {
                  let enteredValue = e.target.value;
                  enteredValue = enteredValue.slice(0, 10).replace(/\D/g, '');
                  e.target.value = enteredValue;
                }}
                onChange={(e) => { setdata(e) }}
                required
              />
            </div>
            <div className="mx-3" style={{ width: "33rem" }}>
              <label>Email*:</label>
              <input type="email" id="Email" placeholder="Enter Email" className="form-control" required onChange={(e) => { setdata(e) }} />
            </div>
          </div>

          <hr></hr>
          <h5 style={{ textAlign: "center" }}><b>This Will Used For The Refund Process</b></h5>
          <hr></hr>
          <div className="bidder_register_form">
            <div className="mx-3" style={{ width: "33rem" }}>
              <label>Bank Name*:</label>
              <input type="text" id="BANK_NAME" placeholder="Enter Bank Name" className="form-control" required onChange={(e) => { setdata(e) }} />
            </div>
            <div className="mx-3" style={{ width: "33rem" }}>
              <label>Account Holder Name*:</label>
              <input type="text" id="Account_HolderName" placeholder="Enter Account Holder Name" className="form-control" required onChange={(e) => { setdata(e) }} />
            </div>
          </div>
          <div className="bidder_register_form">
            <div className="mx-3" style={{ width: "33rem" }}>
              <label>Account Number*:</label>
              <input type="text" id='checkacnumber' placeholder="Enter Account Number" className="form-control" required onChange={(e) => { setdata(e) }} />
            </div>
            <div className="mx-3" style={{ width: "33rem" }}>
              <label> Confirm Account Number*:</label>
              <input type="text" id="Account_Number" placeholder="Confirm Account Number" className="form-control" required onChange={(e) => { setdata(e) }} />
              <b style={{ color: accountnum === false ? 'red' : 'green' }}>{accountnum === false ? 'Acc number doesnot match' : 'Matched'}</b>
            </div>
          </div>
          <div className="bidder_register_form">
          <div className="mx-3" style={{ width: "33rem" }}>
              <label>IFSC Code*:</label>
              <input type="text" id="IFSC_CODE" placeholder="Enter IFSC Code" className="form-control" required onChange={(e) => { setdata(e); validateIfsc() }} style={{ textTransform: 'uppercase' }} />
              <b style={{ color: isIfscValid === false ? 'red' : 'green' }}>{isIfscValid === false ? 'IFSC code is invalid' : 'IFSC code is valid'}</b>
            </div>
            <div className="mx-3" style={{ width: "33rem" }}>
              <label>Branch Name*:</label>
              <input type="text" id="BranchName" placeholder="Branch Name" className="form-control" required onChange={(e) => { setdata(e) }} />
            </div>
          </div>

          <div className="bidder_register_form">
            <button className="btn btn-success my-3 mx-5" type="submit" >Submit</button>
            <Link to={'/Dashboard/DownloadReciept/' + forminf.Tender_ID + '/' + forminf.GST_No + '/' + forminf.PAN_No} hidden={recieptview} >Download Reciept</Link>
          </div>
        </Form>
      </div>
     </div>


    </div>

  );
};

export default BidderRegister;
